var escape = require("../../../../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fmcy-product-zoomer-modal .fmcy-menu-item-btn-close {\n  cursor: pointer;\n  background-image: url(" + escape(require("../img/btn-close.png")) + ");\n  background-repeat: no-repeat;\n  background-position: top right;\n  background-size: cover;\n  width: 32px;\n  height: 32px;\n  z-index: 1000;\n  position: absolute;\n  right: 5px;\n  top: 5px;\n  opacity: 1; }\n\n.fmcy-product-zoomer-modal .fmcy-zoomer-branding-region {\n  position: absolute;\n  bottom: 10px;\n  left: 12px;\n  z-index: 1000;\n  opacity: 0.7; }\n  .fmcy-product-zoomer-modal .fmcy-zoomer-branding-region .fmy-branding-f {\n    width: 53px;\n    height: 75px; }\n", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./assets/js/common/menu/menu-item-expanded/product-zoomer-modal/product-zoomer-modal.scss
 ** module id = 1014
 ** module chunks = 1 81
 **/